import { css } from "@emotion/css";
import { Trans, useTranslation } from "react-i18next";

import { EmptyState } from "../../components/EmptyState/EmptyState";
import { useUser } from "../../hooks/api/useUser";
import { getPrimaryName } from "../../utils/user-utils";

export function DashboardEmpty() {
  const { t } = useTranslation();
  const { user } = useUser();

  const userName = user && getPrimaryName(user);

  return (
    <div className={css({ margin: "auto" })}>
      <EmptyState
        hideBorder
        illustration="check-todo"
        size={132}
        title={t("Welcome, {{firstName}}!", {
          firstName: userName?.first_name,
        })}
        description={
          <Trans>
            When someone sends you a background check, it will appear here.
          </Trans>
        }
      />
    </div>
  );
}
